export default "__VITE_ASSET__CbYwgrlw__"